import { create } from 'zustand';
import type { ColorData } from '@/(routers)/boards/editor/block/definitions/fields/fieldColorSequence';

type RgbLedFieldRef = {
    setColors: (colors: ColorData[]) => void;
    getColors: () => ColorData[];
};

interface BlockModalRgbLedState {
    fieldRef: RgbLedFieldRef | null;
    onConfirm: (() => void) | null;
    setFieldRef: (ref: RgbLedFieldRef) => void;
    setOnConfirm: (fn: () => void) => void;
    clearFieldRef: () => void;
}

export const useBlockModalRgbLedStore = create<BlockModalRgbLedState>((set) => ({
    fieldRef: null,
    onConfirm: null,
    setFieldRef: (ref) => set({ fieldRef: ref }),
    setOnConfirm: (fn) => set({ onConfirm: fn }),
    clearFieldRef: () => set({ fieldRef: null, onConfirm: null }),
}));
